/* eslint-disable consistent-return */
/* eslint-disable no-unreachable-loop */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';

// routes
import { useNavigate } from 'react-router-dom';

// components
import HearroCommontable from '../../../components/hearro/table/HearroCommonTable';
import CommonPagination from '../../../components/pagination/CommonPagination';
import CommonModal from '../../../components/modal/CommonModal';

// apis
import {
	deletePatientFromHearro,
	getPatientCountFromHearro,
	getPatientFromHearro,
	getPsctCodeFromHearro,
	postPatientToHearro,
} from '../../../services/apis/hearro/patient';

// utils
import { hasForbiddenChars, FORBIDDEN_CHARS_MSG, sanitizeText } from '../../../utils/sanitize';

function HearroPatientManageListPage() {
	const navigate = useNavigate();

	const searchOption = [
		{ key: 'psctId', value: '전체' },
		{ key: 'display_name', value: '이름' },
	];

	const patientListTableHeader = [
		{ key: 'psctId', value: '번호' },
		{ key: 'displayName', value: '이름' },
		{ key: 'phoneNumber', value: '휴대폰 번호' },
		{ key: 'nickName', value: '닉네임' },
		{ key: 'birth', value: '생년월일' },
		{ key: 'sex', value: '성별' },
		{ key: 'isHearAid', value: '보청기 착용' },
		{ key: 'psctCode', value: '처방코드' },
		{ key: 'progress', value: '훈련' },
	];

	const [selectedSearchOption, setSelectedSearchOption] = useState(searchOption[0].key);

	const [patientListTableData, setPatientListTableData] = useState([]);

	const [tablePageCnt, setTablePageCnt] = useState(1);

	const [selectedPage, setSelectedPage] = useState(1);

	const [tempSearchKeyword, setTempSearchKeyword] = useState('');

	const [searchKeyword, setSearchKeyword] = useState('');

	const [selectedPatients, setSelectedPatients] = useState([]);

	async function SetPageCount(searchtext = null) {
		try {
			const request = {
				searchtext,
			};
			const res = await getPatientCountFromHearro(request);
			if (parseInt(res.status / 200, 10) === 1) {
				const totalCount = res.data || 0;
				setTablePageCnt(Math.ceil(totalCount / 10) || 1);
				return;
			}
			throw new Error();
		} catch (err) {
			console.error(err);
			setTablePageCnt(1);
		}
	}

	async function SetPatientData(searchtext = null, page = 1) {
		try {
			const res = await getPatientFromHearro({ searchtext, page, order: selectedSearchOption });
			if (parseInt(res.status / 200, 10) === 1) {
				const formatted = (res.data || []).map(e => ({
					...e,
					...('isHearAid' in e && { isHearAid: e.isHearAid ? '착용' : '미착용' }),
					...('birth' in e && {
						birth: `${e.birth.substr(0, 4)}-${e.birth.substr(4, 2)}-${e.birth.substr(6, 2)}`,
					}),
					...('sex' in e && { sex: e.sex === 'M' ? '남성' : '여성' }),
					...('phoneNumber' in e && {
						phoneNumber: `${e.phoneNumber.substr(0, 3)}-${e.phoneNumber.slice(
							3,
							e.phoneNumber.length - 4,
						)}-${e.phoneNumber.substr(e.phoneNumber.length - 4, 4)}`,
					}),
				}));
				setPatientListTableData(formatted);
				return;
			}
			throw new Error();
		} catch (err) {
			console.error(err);
			setPatientListTableData([]);
		}
	}

	function GetNewTableDataByPagination(page) {
		setSelectedPatients([]);
		SetPatientData(searchKeyword, page);
		SetPageCount(searchKeyword);
	}

	function GetNewTableDataBySearch() {
		if (hasForbiddenChars(searchKeyword)) return;
		SetPatientData(searchKeyword, 1);
		SetPageCount(searchKeyword);
		setSelectedPage(1);
	}

	function GoToSelectedPatientDetail(selectedPatient) {
		if (!selectedPatient.pid || selectedPatient.pid === 'Not_linked') {
			alert('앱에서 등록이 필요한 환자입니다.');
			return;
		}
		navigate(`/dtx002/patient-manage/list/${selectedPatient.pid}`);
	}

	useEffect(() => {
		SetPatientData();
		SetPageCount();
	}, []);

	useEffect(() => {
		GetNewTableDataBySearch();
	}, [searchKeyword]);

	useEffect(() => {
		GetNewTableDataByPagination(1);
		setSelectedPage(1);
	}, [selectedSearchOption]);

	// 신규 환자 추가 modal

	const [showRegisterPatientModal, setShowRegisterPatientModal] = useState(false);
	const [newPatientDisplayName, setNewPatientDisplayName] = useState('');
	const [newPatientGender, setNewPatientGender] = useState('');
	const [newPatientPhone1, setNewPatientPhone1] = useState('');
	const [newPatientPhone2, setNewPatientPhone2] = useState('');
	const [newPatientPhone3, setNewPatientPhone3] = useState('');
	const [newPatientBirthYear, setNewPatientBirthYear] = useState(new Date().getFullYear());
	const [newPatientBirthMonth, setNewPatientBirthMonth] = useState(new Date().getMonth() + 1);
	const [newPatientBirthDay, setNewPatientBirthDay] = useState(new Date().getDate());
	const [newPatientDoctorCode, setNewPatientDoctorCode] = useState('');

	const birthYear = () => {
		const yearItems = [];
		for (let year = 1900; year <= new Date().getFullYear(); year++) {
			yearItems.push(
				<option key={year} value={year}>
					{year}
				</option>,
			);
		}
		return yearItems;
	};
	const birthMonth = () => {
		const monthItems = [];
		for (let month = 1; month <= 12; month++) {
			monthItems.push(
				<option key={month} value={month}>
					{month}
				</option>,
			);
		}
		return monthItems;
	};
	const birthDay = () => {
		const dayItems = [];
		for (let day = 1; day <= 31; day++) {
			dayItems.push(
				<option key={day} value={day}>
					{day}
				</option>,
			);
		}
		return dayItems;
	};

	async function CreatePsctCode() {
		try {
			const resp = await getPsctCodeFromHearro();
			if (parseInt(resp.status / 200, 10) === 1) {
				setNewPatientDoctorCode(resp.data);
			}
		} catch (err) {
			console.error(err);
			// 에러 발생 시 임시로 랜덤 코드 생성
			const randomCode = Math.floor(Math.random() * 1000000)
				.toString()
				.padStart(6, '0');
			setNewPatientDoctorCode(randomCode);
		}
	}

	async function RegisterNewPatient() {
		if (hasForbiddenChars(newPatientDisplayName) || hasForbiddenChars(newPatientDoctorCode.toString())) {
			return;
		}
		if (
			newPatientDisplayName.replace(/\s/g, '') !== '' &&
			newPatientGender.replace(/\s/g, '') !== '' &&
			newPatientPhone1.replace(/\s/g, '') !== '' &&
			newPatientPhone2.replace(/\s/g, '') !== '' &&
			newPatientPhone3.replace(/\s/g, '') !== '' &&
			newPatientDoctorCode.toString().replace(/\s/g, '') !== ''
		) {
			try {
				const queryStringRequest = {
					displayName: sanitizeText(newPatientDisplayName),
					sex: newPatientGender,
					phoneNumber: newPatientPhone1 + newPatientPhone2 + newPatientPhone3,
					doctorCode: newPatientDoctorCode,
					birth:
						newPatientBirthYear.toString() +
						newPatientBirthMonth.toString().padStart(2, 0) +
						newPatientBirthDay.toString().padStart(2, 0),
				};
				const resp = await postPatientToHearro(queryStringRequest);
				if (parseInt(resp.status / 200, 10) === 1) {
					CloseRegisterPatientModal();
					SetPatientData(searchKeyword, 1);
					SetPageCount(searchKeyword);
					setSelectedPage(1);
				} else {
					// 이미 존재하는 환자일 경우 팝업 띄우기
					if (resp.response?.data?.message?.includes('duplicate')) {
						setShowExistPatientModal(true);
						return;
					}

					throw new Error();
				}
			} catch (err) {
				console.error(err);
				alert('신규 환자 추가에 실패하였습니다.');
			}
		} else {
			alert('환자 정보를 모두 입력해주세요.');
		}
	}

	function CloseRegisterPatientModal() {
		setShowRegisterPatientModal(false);
		setNewPatientDisplayName('');
		setNewPatientGender('');
		setNewPatientPhone1('');
		setNewPatientPhone2('');
		setNewPatientPhone3('');
		setNewPatientBirthYear(new Date().getFullYear());
		setNewPatientBirthMonth(new Date().getMonth() + 1);
		setNewPatientBirthDay(new Date().getDate());
		setNewPatientDoctorCode('');
	}

	function disabledCreatePsctCode() {
		if (
			newPatientDisplayName.replace(/\s/g, '') !== '' &&
			newPatientGender.replace(/\s/g, '') !== '' &&
			newPatientPhone1.replace(/\s/g, '') !== '' &&
			newPatientPhone2.replace(/\s/g, '') !== '' &&
			newPatientPhone3.replace(/\s/g, '') !== ''
		) {
			return false;
		} else {
			return true;
		}
	}

	const registerPatientModalBody = (
		<div className="modalbody">
			<div className="formModalItem">
				<div className="formModalItem__label">이름</div>
				<div className="formModalItem__input">
					<input
						type="text"
						className="formModalItem__input__plainText"
						placeholder="이름"
						value={newPatientDisplayName}
						onChange={e =>
							setNewPatientDisplayName(
								e.target.value.replace(/[^ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z\s]/g, ''),
							)
						}
						maxLength={30}
					/>
					{hasForbiddenChars(newPatientDisplayName) && (
						<div className="validation" style={{ color: '#DC3545', marginTop: '0.5rem' }}>
							{FORBIDDEN_CHARS_MSG}
						</div>
					)}
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">성별</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="male"
							value="M"
							name="gender"
							checked={newPatientGender === 'M'}
							onChange={e => setNewPatientGender(e.target.value)}
						/>{' '}
						<label htmlFor="male" className="formModalItem__input__radioLabel">
							남자
						</label>
					</div>
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="female"
							value="F"
							name="gender"
							checked={newPatientGender === 'F'}
							onChange={e => setNewPatientGender(e.target.value)}
						/>{' '}
						<label htmlFor="female" className="formModalItem__input__radioLabel">
							여자
						</label>
					</div>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">휴대폰 번호</div>
				<div className="formModalItem__input">
					<input
						type="text"
						className="formModalItem__input__phoneNumber"
						value={newPatientPhone1}
						onChange={e => {
							const raw = e.target.value;
							const filtered = raw.replace(/[^0-9]/g, '');
							if (filtered.length > 3) {
								setNewPatientPhone1(filtered.slice(0, 3));
							} else {
								setNewPatientPhone1(filtered);
							}
						}}
						size={3}
						maxLength={3}
						placeholder="010"
					/>
					<span className="phoneDivider">-</span>
					<input
						type="text"
						className="formModalItem__input__phoneNumber"
						value={newPatientPhone2}
						onChange={e => {
							const raw = e.target.value;
							const filtered = raw.replace(/[^0-9]/g, '');
							if (filtered.length > 4) {
								setNewPatientPhone2(filtered.slice(0, 4));
							} else {
								setNewPatientPhone2(filtered);
							}
						}}
						size={4}
						maxLength={4}
						placeholder="1234"
					/>
					<span className="phoneDivider">-</span>
					<input
						type="text"
						className="formModalItem__input__phoneNumber"
						value={newPatientPhone3}
						onChange={e => {
							const raw = e.target.value;
							const filtered = raw.replace(/[^0-9]/g, '');
							if (filtered.length > 4) {
								setNewPatientPhone3(filtered.slice(0, 4));
							} else {
								setNewPatientPhone3(filtered);
							}
						}}
						size={4}
						maxLength={4}
						placeholder="5678"
					/>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">생년월일</div>
				<div className="formModalItem__input">
					<select
						className="formModalItem__input__birth"
						onChange={e => setNewPatientBirthYear(e.target.selectedOptions[0].value)}
						value={newPatientBirthYear}
					>
						{birthYear()}
					</select>
					<span className="birthText">년</span>
					<select
						className="formModalItem__input__birth"
						onChange={e => setNewPatientBirthMonth(e.target.selectedOptions[0].value)}
						value={newPatientBirthMonth}
					>
						{birthMonth()}
					</select>
					<span className="birthText">월</span>
					<select
						className="formModalItem__input__birth"
						onChange={e => setNewPatientBirthDay(e.target.selectedOptions[0].value)}
						value={newPatientBirthDay}
					>
						{birthDay()}
					</select>
					<span className="birthText">일</span>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">처방 코드</div>
				<div className="formModalItem__input">
					<input
						type="text"
						readOnly
						className="formModalItem__input__plainTextWithButton"
						placeholder="처방 코드"
						value={newPatientDoctorCode}
						onChange={e => {
							const raw = e.target.value;
							const filtered = raw.replace(/[^0-9]/g, '');
							setNewPatientDoctorCode(filtered);
						}}
						maxLength={10}
					/>
					{hasForbiddenChars(newPatientDoctorCode.toString()) && (
						<div className="validation" style={{ color: '#DC3545', marginTop: '0.5rem' }}>
							{FORBIDDEN_CHARS_MSG}
						</div>
					)}
					<button
						className="submitButton__rounded"
						onClick={CreatePsctCode}
						disabled={disabledCreatePsctCode()}
					>
						생성
					</button>
				</div>
			</div>
		</div>
	);

	const registerPatientModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={() => RegisterNewPatient()}
				disabled={newPatientDoctorCode === ''}
			>
				저장
			</button>
			<button className="cancelButton__rounded" onClick={() => CloseRegisterPatientModal()}>
				취소
			</button>
		</div>
	);

	// 신규 환자 추가 실패 (이미 존재하는 환자) modal

	const [showExistPatientModal, setShowExistPatientModal] = useState(false);

	function CloseExistPatientModal() {
		setShowExistPatientModal(false);
	}

	const existPatientModalBody = <div className="modalbody">이미 등록된 환자입니다.</div>;

	const existPatientModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={() => CloseExistPatientModal()}
				style={{ width: '100%' }}
			>
				확인
			</button>
		</div>
	);

	// 환자 삭제 modal

	const [showDeletePatientModal, setShowDeletePatientModal] = useState(false);

	async function DeleteSelectedPatient() {
		try {
			if (selectedPatients.length === 0) {
				CloseDeletePatientModal();
				return;
			}
			const request = selectedPatients.map(e => e.psctId);
			const res = await deletePatientFromHearro(request);
			if (parseInt(res.status / 200, 10) === 1) {
				CloseDeletePatientModal();
				SetPatientData(searchKeyword, 1);
				SetPageCount(searchKeyword);
				setSelectedPage(1);
				setSelectedPatients([]);
			} else {
				throw new Error();
			}
		} catch (err) {
			console.error(err);
			alert('환자 삭제에 실패하였습니다.');
		}
	}

	function CloseDeletePatientModal() {
		setShowDeletePatientModal(false);
	}

	const deletePatientModalBody = (
		<div className="modalbody">
			<div className="modalbody_text">해당 환자를 삭제하시겠습니까?</div>
			<div className="modalbody_table">
				<table>
					<thead>
						<tr>
							{['번호', '이름', '성별', '전화번호', '생년월일'].map(e => (
								<th key={e}>{e}</th>
							))}
						</tr>
					</thead>
					<tbody>
						{selectedPatients.map((patient, idx) => (
							<tr key={idx}>
								{['psctId', 'displayName', 'sex', 'phoneNumber', 'birth'].map(e => (
									<td key={e}>{patient[e] || '-'}</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);

	const deletePatientModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={() => DeleteSelectedPatient()}
				style={{ width: '100% !important' }}
			>
				삭제
			</button>
			<button
				className="cancelButton__rounded"
				onClick={() => CloseDeletePatientModal()}
				style={{ width: '100% !important' }}
			>
				취소
			</button>
		</div>
	);

	function handleClickDeleteBtn() {
		if (selectedPatients.length > 0) {
			setShowDeletePatientModal(true);
		} else {
			alert('환자를 선택해주세요.');
		}
	}

	return (
		<div className="dashboardContent">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">환자관리</span>
			</div>
			<div className="dashboardContent__inner">
				<div className="patientManageList">
					<div className="patientManageList__search">
						<span className="title">검색 조건</span>
						<div className="search">
							<div className="searchBar">
								<span className="searchBar__label">검색</span>
								<input
									className="searchBar__input"
									type="text"
									placeholder="처방코드, 이름, 닉네임"
									value={tempSearchKeyword}
									onChange={e => setTempSearchKeyword(e.target.value)}
									maxLength={30}
									onKeyDown={e => {
										if (e.key === 'Enter') {
											if (hasForbiddenChars(tempSearchKeyword)) return;
											setSearchKeyword(tempSearchKeyword);
										}
									}}
								/>
								{hasForbiddenChars(tempSearchKeyword) && (
									<div className="validation" style={{ color: '#DC3545', marginTop: '0.5rem' }}>
										{FORBIDDEN_CHARS_MSG}
									</div>
								)}
							</div>
							<button
								className="submitButton__rounded"
								onClick={() => {
									if (hasForbiddenChars(tempSearchKeyword)) return;
									setSearchKeyword(tempSearchKeyword);
								}}
							>
								검색
							</button>
						</div>
					</div>
					<div className="patientManageList__list">
						<div className="patientManageList__list__header">
							<div className="header__title__wrapper">
								<span className="title">환자 리스트</span>
								<select
									className="searchSelect classic"
									value={selectedSearchOption}
									onChange={e => setSelectedSearchOption(e.target.value)}
								>
									<option value="" disabled hidden>
										정렬 조건
									</option>
									{searchOption.map(item => {
										return (
											<option key={item.key} value={item.key}>
												{item.value}
											</option>
										);
									})}
								</select>
							</div>
							<div className="header__option__wrapper">
								<button
									className="submitButton__rounded"
									onClick={() => setShowRegisterPatientModal(true)}
								>
									신규 추가
								</button>
								<button className="submitButton__rounded" onClick={handleClickDeleteBtn}>
									삭제
								</button>
							</div>
						</div>
						<div className="table_wrapper" style={{ paddingTop: '3.125rem' }}>
							<HearroCommontable
								tableHeader={patientListTableHeader}
								tableBody={patientListTableData}
								isCheck
								checkedItems={selectedPatients}
								setCheckedItems={setSelectedPatients}
								isHover
								isClick
								clickEvent={GoToSelectedPatientDetail}
								pageCnt={selectedPage}
								isNumCol={false}
							/>
						</div>
						<CommonPagination
							pageCnt={tablePageCnt}
							selectedPage={selectedPage}
							SetSelectedPage={setSelectedPage}
							GetNewTableData={GetNewTableDataByPagination}
						/>
					</div>
				</div>
			</div>
			{/* 신규 추가 modal */}
			<CommonModal
				header="신규 환자 추가"
				body={registerPatientModalBody}
				footer={registerPatientModalFooter}
				show={showRegisterPatientModal}
				setClose={CloseRegisterPatientModal}
				size="lg"
			/>
			{/* 신규 추가 실패 (이미 존재하는 환자) modal */}
			<CommonModal
				header="신규 환자 등록"
				body={existPatientModalBody}
				footer={existPatientModalFooter}
				show={showExistPatientModal}
				setClose={CloseExistPatientModal}
				size="sm"
			/>
			{/* 환자 삭제 modal */}
			<CommonModal
				header="환자 삭제"
				body={deletePatientModalBody}
				footer={deletePatientModalFooter}
				show={showDeletePatientModal}
				setClose={CloseDeletePatientModal}
				size="lg"
			/>
		</div>
	);
}

export default HearroPatientManageListPage;
